// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3WUAY","footer":"ModalError_footer__2m9Z0"};